import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d1e9d44")

_pushScopeId("data-v-2d1e9d44")
const _hoisted_1 = {
  key: 0,
  class: "container popup-container tag-translations-page",
  id: "tag-translations"
}
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "tag-name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "tag-langs" }
const _hoisted_6 = { class: "tag-lang-title" }
const _hoisted_7 = { class: "pb-27" }
const _hoisted_8 = { class: "tag-lang-footer" }
const _hoisted_9 = { class: "save-tag-lang" }
const _hoisted_10 = { class: "cancel-tag-lang" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.tagItem.name), 1),
          (_ctx.tagItem && _ctx.tagItem.language)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('title.language')), 1),
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_Multiselect, {
                      label: "name",
                      modelValue: _ctx.selectedLang,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedLang = $event)),
                      options: _ctx.languages,
                      canDeselect: false,
                      valueProp: "id",
                      searchable: false,
                      class: "multiselect-style"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagItem.language, (lang, langIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "tag-lang-value",
                      key: langIndex
                    }, [
                      (lang.languageId == _ctx.selectedLang)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => (lang.name = $event)
                          }, null, 8, ["onUpdate:modelValue"])), [
                            [_vModelText, lang.name]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
              }, _toDisplayString(_ctx.$t('button.save')), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel()))
              }, _toDisplayString(_ctx.$t('button.cancel')), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})